import type { RipType } from '@/components/release-in-progress/types'
import { CKI, FLT, MMB } from '@/components/release-in-progress/constants'
import type { IRipScreenDataLayer } from '@/types/DataLayer'
import { pushToDataLayer } from '@/utils/dataLayer'
import { CKIN_LOGIN_PAGE_TYPE, INDEX_PAGE_TYPE, MMB_LOGIN_PAGE_TYPE } from '@/utils/constants/dataLayers'

type RipScreenPageType = IRipScreenDataLayer['page_type']

const pageTypeByRipType: Record<RipType, RipScreenPageType> = {
  [FLT]: INDEX_PAGE_TYPE,
  [MMB]: MMB_LOGIN_PAGE_TYPE,
  [CKI]: CKIN_LOGIN_PAGE_TYPE
}

let lastReportedPage: RipType | undefined

export const clearReleaseInProgressDataLayerState = () => {
  lastReportedPage = undefined
}

export const useReleaseInProgressDataLayer = (getPage: () => RipType) => {
  const { locale } = useI18n()

  watch(
    getPage,
    (page) => {
      if (!import.meta.client || lastReportedPage === page) return

      lastReportedPage = page

      pushToDataLayer({
        event: 'rip_screen',
        event_category: 'impressions',
        page_type: pageTypeByRipType[page],
        site_language: locale.value
      })
    },
    { immediate: true }
  )
}
